import { Injectable } from '@angular/core';
import { KeycloakEvent, KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { KeycloakConfig } from 'keycloak-js';
import { kcConfig } from '../../config';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { formalizedItemFromUrl } from '../utilities/window';

@Injectable({
    providedIn: 'root'
})
export class KeycloakInitializerService {
    private _isInitialized: boolean = false;
    private _initialied$: Subject<void> = new Subject();

    get initialized(): Observable<void> {
        return this._initialied$.asObservable();
    }

    get isInitialized(): boolean {
        return this._isInitialized;
    }

    constructor(private keycloak: KeycloakService,
        private route: Router
    ) { }

    public async initializeKeycloak(): Promise<boolean> {
        if (this._isInitialized) {
            return true;
        }

        const { langPathName } = formalizedItemFromUrl();
        const asset: string = 'assets/silent-check-sso.html';

        try {
            const result = await this.keycloak.init({
                config: kcConfig as KeycloakConfig,
                initOptions: {
                    onLoad: 'check-sso',
                    checkLoginIframe: false,
                    checkLoginIframeInterval: 2,
                    silentCheckSsoFallback: false,
                    enableLogging: false,
                    silentCheckSsoRedirectUri: window.location.hostname == 'localhost' ? null : `${window.location.origin}/${langPathName}/${asset}`
                },
                enableBearerInterceptor: true,
                bearerPrefix: 'Bearer',
                bearerExcludedUrls: ['/assets'],
            });

            this._initialied$.next();
            this._isInitialized = true;

            // Gérer les événements Keycloak
            this.keycloak.keycloakEvents$.subscribe(async (event: KeycloakEvent) => {
                switch (event.type) {
                    case KeycloakEventType.OnTokenExpired:
                        await this.keycloak.getKeycloakInstance().updateToken(1);
                        break;
                    case KeycloakEventType.OnAuthRefreshError:
                        location.href = location.host;
                        break;
                }
            });
            console.log("result", result);

            return result;
        } catch (error: any) {
            console.log("KC INIT ERROR", error);
        }
    }
}
